import React from 'react';

import { StyleSheet } from 'react-native';

import { Box, BoxProps, withTypography } from 'components/ui';
import { primitive, spacing } from 'styles/constants';

const styles = StyleSheet.create({
  container: {
    backgroundColor: primitive.$white,
    borderRadius: 12,
    paddingBottom: spacing.$6,
    width: '100%',
  },
  title: {
    marginBottom: spacing.$2,
    marginTop: spacing.$6,
  },
  benefitText: {
    marginBottom: spacing.$2,
  },
  contentText: {
    margin: 0,
  },
  infoContainer: {
    alignItems: 'center',
    marginTop: spacing.$4,
  },
  infoBadge: {
    alignItems: 'center',
    backgroundColor: primitive.$blueLight,
    borderRadius: spacing.$2,
    height: spacing.$8,
    justifyContent: 'center',
    padding: spacing.$2,
  },
  infoText: {
    margin: 0,
  },
  sectionTitle: {
    marginVertical: spacing.$6,
  },
});

export const Container = ({ style, ...props }: BoxProps) =>
  React.createElement(Box, { ...props, style: [styles.container, style] });

export const Title = withTypography({
  variant: 'headerThree',
  fontSize: 'md',
  textAlign: 'center',
  style: styles.title,
});

export const BenefitText = withTypography({
  variant: 'headerThree',
  bold: true,
  fontSize: '6xl',
  textAlign: 'center',
  lineHeight: 82, // 1.375em x 60px (original lineHeight: 'md'),
  style: styles.benefitText,
});

export const ContentText = withTypography({
  variant: 'headerThree',
  fontSize: 'xl',
  color: primitive.$bbqBrown,
  textAlign: 'center',
  lineHeight: 28, // 1.4em x 20px,
  style: styles.contentText,
});

export const InfoContainer = ({ style, ...props }: BoxProps) =>
  React.createElement(Box, { ...props, style: [styles.infoContainer, style] });

export const InfoBadge = ({ style, ...props }: BoxProps) =>
  React.createElement(Box, { ...props, style: [styles.infoBadge, style] });

export const InfoText = withTypography({
  variant: 'headerThree',
  fontSize: 'sm',
  textAlign: 'center',
  color: primitive.$blueWalmart,
  style: styles.infoText,
});

export const SectionTitle = withTypography({
  variant: 'headerThree',
  fontSize: 'xl',
  textAlign: 'center',
  lineHeight: 28, // 1.4em x 20px,
  style: styles.sectionTitle,
});
